<template>
    <div class="px-8 py-6 space-y-4 bg-white border shadow-sm border-zinc-100 hover:border-clay-500 rounded-xl">
        <div class="py-1 -mx-4 -mt-10 text-xs font-semibold text-center text-white uppercase rounded-lg bg-gradient-to-r from-cyan-600 to-cyan-500"
            v-if="audition.isFeatured">
            Featured</div>
        <div class="block text-left">
            <div class="flex-auto min-w-0 space-y-2">
                <h3 class="text-lg font-semibold leading-6 text-gray-900">
                    <a :href="`/opportunities/auditions-jobs/legacy/${audition.urlSlug}`" :title="audition.showTitle">
                        {{ audition.showTitle }}
                    </a>
                </h3>
                <p class="flex mt-1 text-sm font-medium text-slate-600">
                    <span class="">{{ audition.categories.join(', ') }}</span>
                </p>
            </div>

        </div>
        <div class="z-10">
            <div v-if="audition.organizationName">
                <p class="text-sm text-slate-600" :title="audition.organizationName">
                    {{ audition.organizationName }}
                </p>
            </div>
            <div class="">
                <p class="text-sm text-slate-600" :title="audition.shortAddressPrettified">
                    <svg class="inline-block w-3 h-3 mr-2 opacity-80 text-inherit" xmlns="http://www.w3.org/2000/svg"
                        height="16" width="18" fill="currentColor" viewBox="0 0 576 512">
                        <path class="fa-secondary" opacity=".4"
                            d="M416 503V200.4c3.5-6.9 6.7-13.8 9.6-20.6c.5-1.2 1-2.5 1.5-3.7l116-46.4C558.9 123.4 576 135 576 152V422.8c0 9.8-6 18.6-15.1 22.3L416 503zM15.1 187.3l122.6-49c2.4 14.1 7.2 28.3 12.8 41.5c2.9 6.8 6.1 13.7 9.6 20.6V451.8L32.9 502.7C17.1 509 0 497.4 0 480.4V209.6c0-9.8 6-18.6 15.1-22.3zM384 255V504.3L192 449.4V255c20.5 31.3 42.3 59.6 56.2 77c20.5 25.6 59.1 25.6 79.6 0c13.9-17.4 35.7-45.7 56.2-77z" />
                        <path class="fa-primary"
                            d="M302.8 312C334.9 271.9 408 174.6 408 120C408 53.7 354.3 0 288 0S168 53.7 168 120c0 54.6 73.1 151.9 105.2 192c7.7 9.6 22 9.6 29.6 0zM288 72a40 40 0 1 1 0 80 40 40 0 1 1 0-80z" />
                    </svg>
                    {{ audition.shortAddressPrettified }}
                </p>
            </div>
            <div v-if="audition.compensation.startsWith('Paid')" class="py-2 text-sm text-clay-800">
                <svg class="inline-block w-4 h-4 mr-2 opacity-80 text-inherit" xmlns="http://www.w3.org/2000/svg"
                    height="1em" fill="#eab308" viewBox="0 0 512 512">
                    <path class="fa-secondary" opacity=".4"
                        d="M311.1 38.9c9.4-9.3 24.6-9.2 33.9 .2L472.8 168.4c52.4 53 52.4 138.2 0 191.2L360.8 472.9c-9.3 9.4-24.5 9.5-33.9 .2s-9.5-24.5-.2-33.9L438.6 325.9c33.9-34.3 33.9-89.4 0-123.7L310.9 72.9c-9.3-9.4-9.2-24.6 .2-33.9z" />
                    <path class="fa-primary"
                        d="M0 80V229.5c0 17 6.7 33.3 18.7 45.3l168 168c25 25 65.5 25 90.5 0L410.7 309.3c25-25 25-65.5 0-90.5l-168-168c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                </svg>
                Paid
            </div>

        </div>
    </div>
</template>

<script lang="ts" setup>
// @ts-ignore
import {defineProps, Ref, ref} from "vue";
import {AuditionDTO} from "@/dtos";

const props = defineProps({
    audition: {
        default: {}
    }
})

const audition:AuditionDTO = props.audition;

</script>
<style>

</style>